import { DownOutlined, InfoCircleOutlined, createFromIconfontCN } from '@ant-design/icons';
import { RootStoreModel } from "@redux/reducers";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Divider,
  Image,
  List,
  Menu,
  Row,
  Space,
  Spin,
  Table,
  Tooltip,
  notification
} from "antd";
import QRCode from "qrcode.react";
import { useEffect, useState } from "react";
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { abmDepInfo } from "../../axios/api.app";
import {
  addSkipsteps, getAPNDetail,
  getAbmDevices,
  getIosScanCodeSrc,
  getMacOSMobileconfig,
  getMobileconfig,
  getSkipsteps,
  setAbmDevices, setAbmDevicesAll
} from "../../axios/api.enroll";
import { gaEvent } from "../../withTracker";

import i18n from "@src/locales";
import { useTranslation } from "react-i18next";

const { Column } = Table;
const MyIcon = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2670925_pf3sykyocl.js', // 在 iconfont.cn 上生成
});
const envObj = process.env;
export const EnrollmentIOS = () => {
  const [imggeSrc, setImggeSrc] = useState<string>("");
  const [current, setCurrent] = useState<string>("iOS");
  const [showTable, setShowtable] = useState<boolean>(false);
  const [showConfig, setShowConfig] = useState<boolean>(false);
  const [tableList, setTableList] = useState<any[]>([]);
  const [selectKeys, setSelectKeys] = useState<string[]>([]);
  const [skipsteps, setSkipsteps] = useState<any>();
  const [selectSkipsteps, setSelectSkipsteps] = useState<any[]>([]);
  const [checkAll, setCheckAll] = useState<boolean>(false);
  const [activationLock, setActivationLock] = useState<boolean>(false);
  const [enableRootOrganization, setEnableRootOrganization] = useState<boolean>(false);
  const [indeterminate, setIndeterminate] = useState<boolean>(false);
  const [mobileConfigUrl, setMobileConfigUrl] = useState<string>("");
  const [macOsMobileConfigUrl, setMacOSMobileConfigUrl] = useState<string>("");
  const [cursor, setCursor] = useState<string>("");
  const [moreToFollow, setMoreToFollow] = useState<boolean>(true);
  const [loading, setLoading] = useState(false);
  const [prifileDeviceAllLoading, setPrifileDeviceAllLoading] = useState(false);
  const [registAllLoading, setRegistAllLoading] = useState(false);
  const [isSetApn, setIsSetApn] = useState(false);
  const [isSetAbm, setIsSetAbm] = useState(false);
  const [verifyUrl, setVerifyUrl] = useState<string>("");
  const { t } = useTranslation();
  var pagesize = 10;
  const account = useSelector(
    (store: RootStoreModel) => {
      if (store.userState.account.companyId && !verifyUrl) {
        var url = `${envObj.REACT_APP_API_URL}/apns/mobileconfig/normal?companyId=${store.userState.account.companyId}`
        if (store.userState.account.accountType === "WeChat") {
          url += `&wid=${store.userState.account.account}`
        }
        setVerifyUrl(btoa(url))
      }
      return store.userState.account
    }
  );
  useEffect(() => {
    getAPNDetail().then((res: any) => {
      if (res) {
        setIsSetApn(true);
        getIosScanCodeSrc().then((res) => {
          setImggeSrc("data:image/jpg;base64," + res)
          //getDevices();
        });
      } else {
        setIsSetApn(true);
        notification.error({ message: t("请先配置APNs") })
      }
      setMobileConfigUrl(getMobileconfig(account.companyId))
      var macConfigUrl = getMacOSMobileconfig(account.companyId);
      var eUrl = btoa(macConfigUrl);
      var macUrl = `${window.location.origin}/iosverify.html?v_1=${eUrl}`;
      setMacOSMobileConfigUrl(macUrl);
    })
    abmDepInfo().then((res) => {
      if(res.length){
        setIsSetAbm(true)
      }else{
        setIsSetAbm(false)
      }

    })
  }, []);

  const getDevices = () => {
    getAbmDevices({ pagesize: pagesize, cursor: cursor }).then(res => {
      if (res?.devices && res.devices.length != 0) {
        var ses: string[] = []
        res.devices?.forEach((ele: any) => {
          ele.disabled = ele.profileAssignmentResult;
          if (ele.profileAssignmentResult) {
            ses?.push(ele.serial_number)
          }
        });
        // for(var i=0;i<10;i++){
        //   res.devices.push({model: res.devices.length})
        // }
        setSelectKeys(ses);
        setCursor(res.cursor);
        setMoreToFollow(res.more_to_follow);
      }
      setTableList(res?.devices)
    }, () => { })
  }
  const onChange = (selectedRowKeys: any[], selectedRows: any[]) => {
    setSelectKeys(selectedRowKeys)
  }
  const handleClick = (e: any) => {
    setShowtable(false);
    setCurrent(e.key)
  };
  const rowSelection = {
    selectedRowKeys: selectKeys,
    onChange: onChange,
    getCheckboxProps: (record: any) => ({
      disabled: record.profileAssignmentResult, // Column configuration not to be checked
      name: record.name,
    }),
  };
  const setAbmDevicesClick = () => {
    var selectItem: any[] = [];
    tableList.forEach(ele => {
      if (!ele.disabled && ele.profileAssignmentResult) {
        selectItem.push(ele.serial_number)
      }
    })
    if (selectItem.length == 0) {
      return;
    }
    setAbmDevices(selectItem).then(res => {
      notification.success({ message: t("成功") });
      setSelectKeys([]);
      getDevices();
    })
  }
  const checkboxChange = (checkedValues: any) => {
    console.log('checked = ', checkedValues);
    //setSelectSkipsteps(checkedValues);
    setSelectSkipsteps(checkedValues);
    var allCount = skipsteps.Common.length + skipsteps.IOS.length + skipsteps.macOS.length;
    var opts = indeterminate
    setIndeterminate(!!checkedValues.length && checkedValues.length < allCount);
    setCheckAll(checkedValues.length === allCount);
  }
  const showConfigClick = () => {
    getSkipsteps().then(c => {
      var keys: any[] = [];

      if (c.AutoAdvanceSetup) {
        c.Common.forEach((ele: any) => {
          keys.push(ele.Key)
        });
        c.IOS.forEach((ele: any) => {
          keys.push(ele.Key)
        });
        c.macOS.forEach((ele: any) => {
          keys.push(ele.Key)
        });

      } else {
        c.Common.forEach((ele: any) => {
          if (ele.IOSChecked) {
            keys.push(ele.Key)
          }

        });
        c.IOS.forEach((ele: any) => {
          if (ele.IOSChecked) {
            keys.push(ele.Key)
          }
        });
        c.macOS.forEach((ele: any) => {
          if (ele.IOSChecked) {
            keys.push(ele.Key)
          }
        });
      }
      setActivationLock(c.ActivationLock);
      //setEnableRootOrganization(c.EnableRootOrganization);
      setCheckAll(c.AutoAdvanceSetup);
      setSelectSkipsteps(keys);
      setSkipsteps(c)
    })
  }
  const onCheckAllChange = (e: any) => {
    var keys: any[] = [];
    if (e.target.checked) {
      skipsteps.Common.forEach((ele: any) => {
        keys.push(ele.Key)
      });
      skipsteps.IOS.forEach((ele: any) => {
        keys.push(ele.Key)
      });
      skipsteps.macOS.forEach((ele: any) => {
        keys.push(ele.Key)
      });
    }
    setSelectSkipsteps(keys);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };
  const onActivationLockChange = (e: any) => {
    setActivationLock(e.target.checked)
  };

  const onEnableRootOrganizationChange = (e: any) => {
    setEnableRootOrganization(e.target.checked)
  };

  const configSaveClick = () => {    
    addSkipsteps({
      keys: selectSkipsteps, 
      autoAdvanceSetup: checkAll, 
      activationLock: activationLock, 
      enableRootOrganization: true
    }).then(() => {
      setShowConfig(false);
      notification.success({ message: t("成功") });
      // getDevices();
    })

  }

  const loadMoreData = () => {
    if (loading) {
      return;
    }
    console.log("loadMoreData")
    setLoading(true);

    // var timer = setInterval(function () {
    //   for(var i=0;i<10;i++){
    //     tableList.push({model:tableList.length})
    //   }
    //   setTableList([...tableList]);
    //   if(tableList.length>100){
    //     setMoreToFollow(false);
    //   }
    //   console.log("添加")
    //   clearInterval(timer);
    // }, 1000);
    getAbmDevices({ pagesize: pagesize, cursor: cursor }).then(res => {
      if (res?.devices && res.devices.length != 0) {

        res.devices?.forEach((ele: any) => {
          ele.disabled = ele.profileAssignmentResult;
          tableList.push(ele);

          // if (ele.profileAssignmentResult) {
          //   selectKeys.push(ele.serial_number)
          // }
        });

        setTableList([...tableList]);
        setSelectKeys([...selectKeys]);
        setCursor(res.cursor);
        setMoreToFollow(res.more_to_follow);
        setLoading(false);
      }


    }, () => { })
  }
  const selectClick = (index: number) => {
    tableList[index].profileAssignmentResult = !tableList[index].profileAssignmentResult;
    setTableList([...tableList])
  }
  const checkAllChange = (e: any) => {
    if (e.target.checked) {
      tableList.forEach(ele => {
        if (!ele.disabled && !ele.profileAssignmentResult) {
          ele.profileAssignmentResult = true;
        }
      });
      setTableList([...tableList]);
    } else {
      tableList.forEach(ele => {
        if (!ele.disabled && ele.profileAssignmentResult) {
          ele.profileAssignmentResult = false;
        }
      });
      setTableList([...tableList]);
    }
  }
  const profileDeviceAll = (type = "") => {
    if (type === "all") {
      setRegistAllLoading(true);
      setAbmDevicesAll().then((res) => {
        notification.success({ message: res })
      }).finally(() => {
        setRegistAllLoading(false)
      })
    } else {
      setPrifileDeviceAllLoading(true);
      setAbmDevices([]).then(res => { 
        notification.success({ message: res })
      }).finally(() => {
        setPrifileDeviceAllLoading(false)
      })
    }
  }
  return (
    <div >
      <div className="breadcrumbTop py-2" >
        <Breadcrumb>
          <Breadcrumb.Item>{t("注册")}</Breadcrumb.Item>
          <Breadcrumb.Item>{t("苹果")}</Breadcrumb.Item>
          {/* <Breadcrumb.Item ><a onClick={() => { setShowtable(false); }}>{current === "ABM" ? "ABM/ASM" : current}</a></Breadcrumb.Item> */}
          {showTable && (<Breadcrumb.Item>{t("同步")}</Breadcrumb.Item>)}
        </Breadcrumb>
        <Row style={{padding: "32px 0 19px 0"}}>
            <Space>
                <img src="/images/appleIcon.svg" alt="" />
                <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("苹果")}</span>
            </Space>
        </Row>
        <Row>
          <Menu onClick={handleClick} selectedKeys={[current]} mode="horizontal" style={{borderBottom: 0, marginLeft: -20, width: "100%"}}>
            <Menu.Item key="iOS">iOS</Menu.Item>
            <Menu.Item key="macOS">macOS</Menu.Item>
            {/* <Menu.Item key="AC2">AC2</Menu.Item> */}
            <Menu.Item key="ABM">ABM/ASM</Menu.Item>
          </Menu>
          {(current == "iOS" || current == "macOS") && !isSetApn && (
            <p style={{ margin: "14px 0px 0px 0px", display: "flex", alignItems: "center" }}>
              <img src="/images/tipIcon.svg" alt="" />
              <span style={{ marginLeft: 4, fontSize: 12, fontWeight: 500, color: "#666666" }}>{t("提示")}: {t("可以同步ABM/ASM的设备")}, {t("请先完成")}<Link to="/home/enrollments/settings/apples/APN">{t("配置")}</Link></span>
            </p>
          )}
          {current == "ABM"  && !isSetAbm && (
            <p style={{ margin: "14px 0px 0px 0px", display: "flex", alignItems: "center" }}>
              <img src="/images/tipIcon.svg" alt="" />
              <span style={{ marginLeft: 4, fontSize: 12, fontWeight: 500, color: "#666666" }}>{t("提示")}: {t("注册设备需要先完成苹果配置项")}, {t("现在去")}<Link to="/home/enrollments/settings/apples/ABM">{t("配置")}</Link></span>
            </p>
          )}
          {/* {current == "AC2" && (
            <p style={{ margin: "14px 0px 0px 0px", display: "flex", alignItems: "center" }}>
              <img src="/images/tipIcon.svg" alt="" />
              <span style={{ marginLeft: 4, fontSize: 12, fontWeight: 500, color: "#666666" }}>{t("提示")}: {t("适用于将个人设备或者二手设备绑定到ABM/ASM中进行管控")}</span>
            </p>
          )} */}
        </Row>
      </div>
      {current == "ABM" && (
        <Row style={{ width: "100%" }}>
          {!showTable && (
            <Row style={{ width: "100%" }}>
              <Row className="borderBox" style={{paddingBottom: 10}}>
                {/* <Col span={3} offset={1}><MyIcon type="icon-Macbook_and_iPhone" style={{ fontSize: 120 }}></MyIcon></Col> */}
                <Col span={1}></Col>
                <Image preview={false} src="/images/ipad.png" style={{ width: "120px", paddingTop:"35px",marginLeft:"40px" }}></Image>
                {/* <Col span={4}><Image preview={false} src="/images/ipad.png" style={{ width: "120px", paddingTop:"35px",marginLeft:"20px" }}></Image></Col> */}
                <Col span={1}></Col>
                <Col span={16}>
                  <Space direction="vertical">
                    {/* <div style={{ width: "600px", marginTop: 32 }}>{t("点击同步按钮将ABM/ASM的设备同步到前沿未瓴数字资产平台,并快速加入设备管理列表")}</div> */}
                    <div style={{ width: "600px", marginTop: 32 }}>
                      <Space>
                        <div>
                          <span>{t("点击注册更新/注册全部将ABM/ASM的设备同步到未瓴移动设备管理平台，并快速加入设备管理列表。")}</span>
                          <span>{t("如需将设备先添加到ABM/ASM.")} </span>
                          <a href="https://support.apple.com/zh-cn/guide/apple-configurator/welcome/ios" target="_blank">{t("查看")} </a>
                          <span>{t("如何添加(iOS16以下设备")} <a href="https://support.apple.com/zh-cn/guide/apple-business-manager/axm200a54d59/1/web/1" target="_blank">{t("点击这里")}</a>)</span>
                        </div>
                        <div style={{marginTop: i18n.language === 'zh' ? "-18px" : "-30px"}}>
                          <Tooltip title={t("点击注册更新会添加新的设备，速度更快，如没有部分设备可以点击注册全部。每个整点会有注册全部的定时任务，为避免重复数据整点前后5分钟无法点击注册。")}>
                            <InfoCircleOutlined />
                          </Tooltip>
                        </div>
                      </Space>
                    </div>
                    <div style={{ marginTop: 8 }}> 
                      <Space size="middle">
                        <Button 
                          type="primary" 
                          loading={prifileDeviceAllLoading} 
                          onClick={() => {
                            profileDeviceAll();
                            // gaEvent("enrollmentIos", "onClick", "profileDeviceAll")
                          }}
                        >{t("注册更新")}</Button>
                        {/* <Button 
                          type="primary" 
                          ghost
                          loading={registAllLoading} 
                          onClick={() => {
                            profileDeviceAll("all");
                            gaEvent("enrollmentIos", "onClick", "profileDeviceAll")
                          }}
                        >{t("注册全部")}</Button> */}
                      </Space>
                    </div>
                  </Space>
                </Col>
                <Col span={2} >
                  <div style={{ textAlign: "right", marginTop: 90 }}>
                    <Button variant="outlined" style={{ color: "#0863EB" }} onClick={() => { showConfigClick(); setShowConfig(!showConfig); gaEvent("enrollmentIos", "onClick", "配置") }}>{t("配置")}<DownOutlined /></Button>
                  </div>
                </Col>
              </Row>
              {showConfig && (
                <Row style={{ width: "100%" }}>

                  <Row className="borderBox">
                    <Col span={4} className="enrollmentAbmTitle">{t("默认功能")}</Col>
                    <Col span={20}>  
                      <Row className="checkList" gutter={[16, 16]}>
                        <Col span={10}>
                          <Checkbox onChange={onActivationLockChange} checked={activationLock} style={{marginLeft:16}}></Checkbox>
                          <span>{t("激活锁")}</span>
                        </Col>
                        {/* <Col span={10}>
                          <Checkbox onChange={onEnableRootOrganizationChange} checked={enableRootOrganization} style={{marginLeft: 16}}></Checkbox>
                          <span>{t("默认组织和配置文件")}</span>
                        </Col> */}
                      </Row>
                      <Row className="checkList" gutter={[16, 16]} style={{color: "#bbb"}}>
                        <Col span={10} style={{marginLeft: 16}}>
                          <span style={{display: "flex"}}>{t("设备每次激活时需要输入激活锁信息且无法关闭")}</span>
                        </Col>
                        {/* <Col span={10}>
                          <span style={{display: "flex"}}>{t("分配到根组织并且应用根组织的配置文件")}</span>
                        </Col> */}
                      </Row>
                    </Col>
                  </Row>

                  {/* <Row className="borderBox">
                    <Col span={2} >应用配置文件</Col>
                    <Col span={4} ><Input></Input><p style={{ color: "#9B9B9B", fontSize: 13 }}>将配置文件直接应用在设备中</p></Col>
                    <Col span={2} offset={16} style={{ textAlign: "right" }} ><a style={{ color: "#0863EB" }}>+配置文件</a></Col>
                  </Row> */}
                  {/* <Row className="borderBox">
                    <Col span={6} >
                      <div>  <Checkbox  ></Checkbox ><span style={{ marginLeft: 4 }} >分配组织</span></div>
                      <p style={{ color: "#9B9B9B", fontSize: 13, marginLeft: 16 }}>将设备在注册后直接分配到组织架构中，后期可以更改</p>
                    </Col>
                    <Col span={2} offset={16} style={{ textAlign: "right" }} ><a style={{ color: "#0863EB" }}>+部门</a></Col>
                  </Row> */}
                  <Row className="borderBox">
                    <Row style={{ width: "100%" }}>
                      <Col span={22} className="enrollmentAbmTopTitle">{t("设置跳过激活步骤")}</Col>
                      <Col span={2} style={{ textAlign: "right" }}><span style={{ marginRight: 4 }}>{t("跳过所有步骤")}</span> <Checkbox indeterminate={indeterminate} onChange={onCheckAllChange} value={checkAll}></Checkbox></Col>
                    </Row>
                    <Row style={{ width: "100%" }}>
                      <Divider />
                    </Row>
                    <Checkbox.Group style={{ width: '100%' }} value={selectSkipsteps} onChange={checkboxChange}>
                      <Row style={{width: "100%", marginLeft: 10}}>
                        <Col span={4} className="enrollmentAbmTitle">{t("通用配置")}</Col>
                        <Col span={20} >

                          <Row className="checkList" gutter={[16, 16]}>
                            {skipsteps?.Common?.map((item: any) => (
                              <Col span={6} key={item.Key}>
                                <Checkbox value={item.Key} ></Checkbox >
                                <span>{i18n.language === "zh" ?item.Description:item.Key}</span>
                              </Col>
                            ))}
                          </Row>

                        </Col>
                      </Row>
                      <Divider />
                      <Row className="checkList" style={{ width: "100%", marginTop: 16, marginLeft: 10 }}>
                        <Col span={4}  className="enrollmentAbmTitle" >iPhone/iPad</Col>
                        <Col span={20} >
                          <Row className="checkList" gutter={[16, 16]}>
                            {skipsteps?.IOS?.map((item: any) => (
                              <Col span={6}>
                                <Checkbox value={item.Key} ></Checkbox >
                                <span>{i18n.language === "zh" ?item.Description:item.Key}</span>
                              </Col>
                            ))}
                          </Row>
                        </Col>
                      </Row>
                      <Divider />
                      <Row className="checkList" style={{ width: "100%", marginTop: 16, marginLeft: 10 }}>
                        <Col span={4}  className="enrollmentAbmTitle">Mac</Col>
                        <Col span={20} >
                          <Row className="checkList" gutter={[16, 16]}>
                            {skipsteps?.macOS?.map((item: any) => (
                              <Col span={6} key={item.Key}>
                                <Checkbox value={item.Key} ></Checkbox >
                                <span>{i18n.language === "zh" ?item.Description:item.Key}</span>
                              </Col>
                            ))}
                          </Row>
                        </Col>

                      </Row>
                    </Checkbox.Group>
                  </Row>
                  {/* <Row className="borderBox">
                    <Col span={4}  className="enrollmentAbmTitle">激活锁</Col>
                    <Col span={20}>  <Checkbox onChange={onActivationLockChange} checked={activationLock} style={{marginLeft:16}}  ></Checkbox ></Col>
                  </Row> */}
                  <Row className="borderBox">
                    <Col style={{ textAlign: "center", marginTop: 16 }} span={24} ><Button type="primary" style={{width:190}} onClick={() => { configSaveClick(); gaEvent("enrollmentIos", "onClick", "configSaveClick") }}>{t("保存")}</Button></Col>

                  </Row>
                  {/* <Row className="borderBox">
                    <Col span={4} >共享设备</Col>
                  </Row> */}
                </Row>
              )}

            </Row>
          )}
          {showTable && (
            <div style={{ width: "100%", padding: 36 }}>
              <Row>
                <Col></Col>
                <Col className="ms-auto">
                  <Button type="primary" onClick={() => { setAbmDevicesClick(); gaEvent("enrollmentIos", "onClick", "setAbmDevicesClick") }}>
                    {t("注册更新")}
                  </Button>

                </Col>
              </Row>
              <Row style={{ width: "100%", backgroundColor: "#ffffff", textAlign: "center", fontWeight: "bold", padding: 8, marginBottom: "2px", marginTop: "10px" }}>
                <Col span={1}><Checkbox onChange={checkAllChange} style={{ marginLeft: 16 }} ></Checkbox></Col>
                <Col span={5}>{t("设备")}</Col>
                <Col span={5}>{t("描述")}</Col>
                <Col span={5}>{t("设备类型")}</Col>
                <Col span={4}>{t("平台")}</Col>
                <Col span={4}>{t("系统")}</Col>
              </Row>
              <Spin spinning={loading}>
                <div id="scrollableDiv" style={{
                  width: "100%", height: 500, backgroundColor: "#ffffff", textAlign: "center",
                  overflow: 'auto',
                  padding: '0 16px',
                }}>
                  <InfiniteScroll
                    dataLength={tableList.length}
                    next={loadMoreData}
                    hasMore={moreToFollow}
                    loader={<></>}
                    endMessage={<Divider plain>{t("已经到底了")}</Divider>}
                    scrollableTarget="scrollableDiv"
                  >
                    <List
                      style={{ width: "100%" }}
                      dataSource={tableList}
                      renderItem={(item: any, index: number) => (
                        <List.Item key={item.id} style={{ width: "100%" }}>
                          <Row style={{ width: "100%" }}>
                            <Col span={1}><Checkbox onClick={() => selectClick(index)} disabled={item.disabled} checked={item.profileAssignmentResult}></Checkbox></Col>
                            <Col span={5}>{item.model}</Col>
                            <Col span={5}>{item.description}</Col>
                            <Col span={5}>{item.device_family}</Col>
                            <Col span={4}>{item.os}</Col>
                            <Col span={4}>{item.asset_tag}</Col>
                          </Row>
                        </List.Item>
                      )}
                    />
                  </InfiniteScroll>
                </div>
              </Spin>
              {/* <Table style={{ width: "100%"}}   scroll={{  y: 80}} pagination={false} dataSource={tableList} 
              rowSelection={rowSelection} rowKey={"serial_number"}>
                <Column
                  title="设备"
                  key="model"
                  dataIndex="model"
                ></Column>
                <Column
                  title="描述"
                  key="description"
                  dataIndex="description"
                ></Column>
                <Column
                  title="设备类型"
                  key="device_family"
                  dataIndex="device_family"
                ></Column>
                <Column
                  title="平台"
                  key="os"
                  dataIndex="os"
                ></Column>
                <Column
                  title="系统"
                  key="asset_tag"
                  dataIndex="asset_tag"
                ></Column>
              </Table> */}
            </div>
          )}
        </Row>
      )}

      {current == "iOS" && (
        <Spin spinning={false} >
          <Row style={{ width: "100%" }}>
          <div className="borderBox" style={{paddingLeft:"40px",paddingBottom:"80px"}}>
            {/* <Timeline  style={{ height: 600,marginLeft:16,marginTop:16}}  > */}
                <div>
                  <h5 className="enrollmentNewTitle">{t("第一步")}</h5>
                  <div className="enrollmentDescrobe">
                    {t("使用相机扫码二维码并点击链接")}
                  </div>
                  <div className="mt-3">
                    <QRCode value={`${window.location.origin}/iosverify.html?v_1=${verifyUrl}` || '-'} />
                    {/* <Image src={imggeSrc} alt="" width={150} /> */}
                    {/* <div className="ft-12 text-muted">{t("打开手机浏览器扫码")}</div> */}
                  </div>
                </div>

                <h5  className="enrollmentNewTitle">{t("第二步")}</h5>
                <div className="enrollmentDescrobe">{t("下载文件")}</div>

              {/* <Timeline.Item  dot={<span style={{fontSize:24}}>③</span>}> */}
                <h5 className="enrollmentNewTitle">{t("第三步")}</h5>
                <div className="enrollmentDescrobe">{t("点击通用，安装下载文件")}</div>
              {/* </Timeline.Item> */}
            {/* </Timeline> */}
          </div>
          </Row>
        </Spin>
      )}

      {/* {current == "AC2" && (
        <Spin spinning={false} >
          <div className="borderBox">
            <h4 style={{ marginBottom:16 }}>iOS {t("设备")}</h4>
            <Timeline   style={{marginLeft:16,marginTop:16}} >
              <Timeline.Item dot={<span style={{fontSize:24}}>①</span>}>
                <h5 className="enrollmentTitle">{t("第一步")}：</h5>
                <div className="enrollmentDescrobe">
                  {t("在Mac电脑中打开")}Apple Configurator 2
                </div>
              </Timeline.Item>
              <Timeline.Item  dot={<span style={{fontSize:24}}>②</span>}>
                <h5 className="enrollmentTitle">{t("第二步")}：</h5>
                <div className="enrollmentDescrobe">{t("您的服务器地址")}：{mobileConfigUrl},{t("用于稍后的配置")}</div>
              </Timeline.Item>
              <Timeline.Item dot={<span style={{fontSize:24}}>③</span>}>
                <h5 className="enrollmentTitle">{t("第三步")}：</h5>
                <div><Button ghost type="link" size="small" target="_blank" href="https://bcssstorage.blob.core.chinacloudapi.cn/docs/MDM/AC2%E7%BA%B3%E7%AE%A1iOS%E8%AE%BE%E5%A4%87.pdf">
                  <p>{t("点击此处")}</p>
                </Button>{t("查看操作步骤")}</div>
              </Timeline.Item>
            </Timeline>
            </div>
            <div className="borderBox">
            <h4 style={{ marginBottom:16}}>MacOS {t("设备")}</h4>
            <Timeline style={{marginLeft:16,marginTop:16}}>
              <Timeline.Item dot={<span style={{fontSize:24}}>①</span>}>
                <h5 className="enrollmentTitle">{t("第一步")}：</h5>
                <div className="enrollmentDescrobe">
                  {t("在iPhone中打开")}Apple Configurator 2
                </div>
              </Timeline.Item>

              <Timeline.Item dot={<span style={{fontSize:24}}>②</span>}>
                <h5 className="enrollmentTitle">{t("第二步")}：</h5>
                <div><Button ghost type="link" size="small" target="_blank" href="https://bcssstorage.blob.core.chinacloudapi.cn/docs/MDM/AC2%E7%BA%B3%E7%AE%A1MacOS%E8%AE%BE%E5%A4%87.pdf">
                  <p>{t("点击此处")}</p>
                </Button>{t("查看操作步骤")}</div>
              </Timeline.Item>
            </Timeline>
          </div>
        </Spin>
      )} */}
      {current == "macOS" && (
        <Spin spinning={false} >
          <div className="borderBox" style={{paddingLeft:"40px", paddingBottom:"80px"}}>
                <h5 className="enrollmentNewTitle">{t("第一步")}</h5>
                <div className="enrollmentDescrobe">
                  {t("打开safari输入地址")}:
                  <Button ghost type="link" size="small" target="_blank" href={macOsMobileConfigUrl}>
                    <p>{macOsMobileConfigUrl}</p>
                  </Button>
                </div>
                <h5 className="enrollmentNewTitle">{t("第二步")}</h5>
                <div className="enrollmentDescrobe">{t("下载描述文件")}</div>
                <h5 className="enrollmentNewTitle">{t("第三步")}</h5>
                <div className="enrollmentDescrobe">{t("点击系统偏好设置")}--{t("描述文件")},{t("安装下载文件")}</div>
          </div>
        </Spin>
      )}
    </div>
  );
};
